import { render } from "./LbrxDisplayFirstTheme.vue?vue&type=template&id=09d60bc9&scoped=true"
import script from "./LbrxDisplayFirstTheme.vue?vue&type=script&lang=js"
export * from "./LbrxDisplayFirstTheme.vue?vue&type=script&lang=js"

import "./LbrxDisplayFirstTheme.vue?vue&type=style&index=0&id=09d60bc9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d60bc9"]])

export default __exports__